<template>
	<div>
		<input
			hidden
			type="file"
			accept=".xls, .xlsx, .xlsm"
			ref="loadFile"
			@change="loadApplicantsFile"
		/>
		<p-card class="tw-mb-4">
			<div class="tw-flex tw-justify-between tw-pr-72 tw-px-5">
				<span :style="`color:${$appColors.info}`">
					<b class="uppercase">Nombre del Proceso de Selección: </b> {{ dataProcessSelected.steps.config[0].details.name }}
				</span>
				<span :style="`color:${$appColors.info}`">
					<b class="uppercase">Fecha de Contratación: </b> {{ dataProcessSelected.steps.config[0].details.hireDate | formatDate }}
				</span>
			</div>
		</p-card>
		<div class="tw-flex tw-w-full tw-justify-between tw-items-center tw-gap-x-3">
			<app-tooltip-button
				img="/static/img/excel.svg"
				text="Descargar Reporte Postulantes"
				@click-icon="downloadReportApplicants({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', code: 'general-applicant' })"
			/>
			<div class="tw-flex tw-justify-center tw-items-center tw-gap-x-3">
				<label :style="`color:${$appColors.info}; font-weight: bold;`">Nro. Postulantes Más Idóneos:</label>
				<input type="number" v-model.number="numApplicants" class="filter-input">
				<app-tooltip-button
					img="/static/img/icons/pdf.svg"
					text="Descargar Reporte PDF Postulantes Más Idóneos"
					@click-icon="handleReportRecruitment({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
				/>
				<app-tooltip-button
					img="/static/img/ranking.svg"
					text="Descargar Reporte Postulantes Más Idóneos"
					@click-icon="downloadReportApplicants({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', code: 'ranking-applicant' })"
				/>
			</div>
		</div>
		<div class="tw-flex tw-justify-start tw-gap-4">
			<label :style="`color:${$appColors.info}`">
				Tipo de Proceso:
				<v-select
					outline
					single-line
					hide-details
					multiple
					class="select-core"
					:items="typeProcess.data"
					item-value="id"
					item-text="name"
					@input="getTypeProcess"
					>
				</v-select>
			</label>
			<label :style="`color:${$appColors.info}`">
				Tipo de Postulante:
				<v-select
					outline
					single-line
					hide-details
					multiple
					class="select-core"
					:items="typeApplicant.data"
					item-value="id"
					item-text="name"
					@input="getTypeApplicant"
					>
				</v-select>
			</label>
			<label :style="`color:${$appColors.info}`">
				Plataformas:
				<v-select
					outline
					single-line
					hide-details
					multiple
					class="select-core"
					:items="platforms.data"
					item-value="id"
					item-text="name"
					@input="getTypePlatforms"
					>
				</v-select>
			</label>
		</div>
		<app-table
			class="is-not-selectable no-main-list"
			icon-email
			icon-excel
			formatFile
			btn-actions
			downloadFormat
			title="POSTULANTES:"
			:last-page="lastPage"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			selectable
			:checkAll="checkAll"
			:columns="columns"
			:rows="rows"
			:filter-columns="false"
			@on-page="changePage"
			@on-search-event="onSearchEvent"
			@changeSort="changeSort"
			@changeColor="changeColor"
			@row-is-selected="rowIsSelected"
			@on-selected-all="selectedAll">
			<template slot="sendEmails">
				<app-tooltip-button
					img="/static/img/mail.svg"
					text="Enviar mensajes"
					@click-icon="sendEmails"
				/>
			</template>
			<template slot="applicant">
				<app-tooltip-button
					img="/static/img/import.svg"
					text="Importar Postulantes"
					@click-icon="importApplicants"
				/>
			</template>
			<template slot="excel">
				<app-tooltip-button
					img="/static/img/new.svg"
					text="Agregar"
					@click-icon="addNewApplicant"
				/>
			</template>
			<template slot="formatFile">
				<app-tooltip-button
					img="/static/pdf.png"
					text="Descargar Formato"
					@click-icon="showViewTemplate = true"
				/>
			</template>
			<template slot="action">
				<p-button
					type="primary"
					:extended="true"
					@click="goTo('list-process-recruitment')">Volver</p-button>
			</template>
			<template slot="rows" slot-scope="props">
				<td style="width: 300px; text-align: start; padding-left: 40px;" v-show="showRow(columns, 1)">{{ props.row.applicant.name }} {{ props.row.applicant.lastName }}</td>
				<td v-show="showRow(columns, 2)">{{ props.row.applicant.documentNumber }}</td>
				<td v-show="showRow(columns, 3)">{{ props.row.applicant.phoneNumber }}</td>
				<td v-show="showRow(columns, 4)">{{ props.row.applicant.email }}</td>
				<td v-if="props.row.applicant.cv" v-show="showRow(columns, 5)">
					<a style="text-decoration: none; font-size: 15px;" :href="props.row.applicant.cv" target="_blank">SI</a>
				</td>
				<td v-else v-show="showRow(columns, 5)">NO</td>
				<td v-show="showRow(columns, 6)">
					<template>
						<app-tooltip-button
							icon="circle"
							:color="props.row.state === 275 ? 'success' : 'secondary'"
							:text="props.row.stateProcess ? props.row.stateProcess.name : ''"
						/>
					</template>
				</td>
				<td v-show="showRow(columns, 7)">
					{{ props.row.additionalInformation.typeApplicant.name}}
					<app-tooltip-button
						img="/static/img/change-status.svg"
						size="14"
						text="Cambiar Tipo de Aplicante"
						@click-icon="toggleOptions(props.row.id)"
					/>
					<div v-if="showOptions === props.row.id" class="options-container">
						<div
							v-for="option in typeApplicant.data"
							:key="option.id"
							class="option"
							@click="handlerChangeTypeApplicant(option, props.row, props.index)"
						>
							{{ option.name }}
						</div>
					</div>
				</td>
				<td v-show="showRow(columns, 8)">{{ props.row.sumTotalScores }}</td>
				<td v-show="showRow(columns, 9)" @click.stop="stopClick">
					<v-layout wrap>
						<app-tooltip-button
							img="/static/img/interview.svg"
							:text="messageBtnInterview"
							:disabled="!validatStepInterview"
							@click-icon="InterviewToApplicant(props.row)"/>
						<app-tooltip-button
							img="/static/img/multiple-choice.svg"
							:text="messageButton(props.row)"
							:style="{ cursor: props.row.interview === null ? 'not-allowed' : 'pointer' }"
							:disabled="!validatStepActivities"
							:cursor="props.row.interview === null ? 'not-allowed' : 'pointer'"
							@click-icon="evaluationApplicantDialog(props.row)">
						</app-tooltip-button>
						<app-tooltip-button
							img="/static/img/edit-input.svg"
							size="26"
							text="Editar Postulante"
							@click-icon="handleEditApplicant(props.row)"/>
					</v-layout>
				</td>
			</template>
		</app-table>
		<add-applicant-dialog
			ref="addApplicant"
			:focused-applicant="focusedApplicant"
			:edit-applicant="editApplicant"
			@savedNewApplicant="savedNewApplicant">
		</add-applicant-dialog>
		<list-errors-imports-dialog
			ref="listErrorsImports"
			:list-error="listError">
		</list-errors-imports-dialog>
		<evaluation-applicant-dialog
			v-if="Array.isArray(dataFactors)"
			ref="evaluationApplicant"
			:factors="dataFactors"
			:experience-time="experienceTime"
			@saveEvaluationApplicant="saveEvaluationApplicant">
		</evaluation-applicant-dialog>
		<!-- <v-dialog v-model="showViewTemplate" max-width="500">
			<p-card>
				<p-button
					type="black"
					@click="loadFormat"
					>Descargar Plantilla</p-button>
				<p-button
					type="primary"
					@click="loadExcel"
					>Subir Plantilla</p-button>
			</p-card>
		</v-dialog> -->
		<open-modal
			:footer="false"
			:dialog="showViewTemplate"
			:height="10"
			:small-model="true"
			:title="'Cargar Datos mediante Excel'"
			:close-model="true"
			:persistent="true"
			@close="showViewTemplate = false"
		>
			<div class="tw-flex tw-justify-center tw-items-center tw-gap-12">
				<p-button
					type="black"
					@click="loadFormat"
					>Descargar Plantilla</p-button>
				<p-button
					type="primary"
					@click="loadExcel"
					>Subir Plantilla</p-button>
			</div>
		</open-modal>
		<v-dialog v-model="selectSubsidiary" persistent max-width="500">
			<p-card class="tw-p-none overflow-hidden">
				<p-header-dialog :negative-margin="false" @closeClicked="close()">
					Seleccione la agencia a la que aplica el postulante
				</p-header-dialog>
				<section class="tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6">
					<label
						class="name"
						:style="`color:${$appColors.info}`"
					>
						Agencia
					</label>
					<v-select
						height="37"
						label="Agencia"
						solo
						class="type-select"
						autocomplete
						v-model="subsidiary"
						item-value="id"
						item-text="name"
						:items="subsidiaries"
						:menu-props="{ contentClass: 'type-select-content' }"
						hide-details
						return-object
					></v-select>
				</section>
				<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
					<p-button
						type="primary"
						@click="saveFromModal"
						:disabled="!subsidiary"
						>Guardar
					</p-button>
				</div>
			</p-card>
		</v-dialog>
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import addApplicantDialog from '@/modules/recruitment/components/content/add-applicant-dialog';
import evaluationApplicantDialog from '@/modules/recruitment/components/content/evaluation-applicant-dialog';
import listErrorsImportsDialog from '@/modules/recruitment/components/content/list-errors-imports-dialog';
import openModal from '@/components/configuration/open-modal';
import multiSelect from 'multiselect-dl';
import PMultipleSelect from '@/modules/shared/components/ui/p-multiple-select';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import helper from '@/shared/helper';
import axios from 'axios';
import { pathOr } from 'ramda';
import { mapState } from 'vuex';

const { getLocalData, roundTo, generateBlob, showDownloadDialog } = helper;

export default {
	name: 'list-applicants',
	components: {
		PButton,
		PCard,
		PMultipleSelect,
		addApplicantDialog,
		evaluationApplicantDialog,
		listErrorsImportsDialog,
		openModal,
		multiSelect,
		PHeaderDialog,
	},
	data() {
		return {
			info: {
				data: [
					{ id: 1, name: 'Opción 1' },
					{ id: 2, name: 'Opción 2' },
					{ id: 3, name: 'Opción 3' },
					// Más opciones
				],
			},
			columns: [
				{
					id: 1,
					name: 'NOMBRES Y APELLIDOS',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'last_name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'NRO. IDENTIDAD',
					value: 'document_number',
					visible: true,
				},
				{
					id: 3,
					name: 'TELÉFONO',
					value: 'phone',
					visible: true,
				},
				{
					id: 4,
					name: 'CORREO',
					value: 'email',
					visible: true,
				},
				{
					id: 5,
					name: 'CV',
					value: 'cv',
					visible: true,
				},
				{
					id: 6,
					name: 'ESTADO',
					value: 'state',
					visible: true,
					checked: true,
				},
				{
					id: 7,
					name: 'TIPO',
					value: 'type',
					visible: true,
				},
				{
					id: 8,
					name: 'PUNTAJE',
					value: 'SCORE',
					visible: true,
				},
				{
					id: 9,
					name: 'ACCIONES',
					value: 'actions',
					visible: true,
				},
			],
			params: {
				page: 1,
				limit: 10,
			},
			rows: [],
			lastPage: 0,
			totalItems: 0,
			currentPage: 1,
			focusedApplicant: {},
			dataFactors: {},
			dataInterview: {},
			listError: [],
			experienceTime: {},
			numApplicants: null,
			editApplicant: false,
			showViewTemplate: false,
			dataSelected: [],
			checkAll: false,
			jobDescription: null,
			showOptions: {},
			subsidiaries: [],
			subsidiary: null,
			selectSubsidiary: false,
			option: {},
			row: {},
			additionalInformation: null,
		};
	},
	mounted() {
		document.addEventListener('click', this.handleDocumentClick, true);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick, true);
	},
	beforeCreate() {
		this.$store.dispatch('recruitment/loadCivilStatus');
		this.$store.dispatch('recruitment/loadTypeApplicants');
		this.$store.dispatch('recruitment/loadTypeProcess');
		this.$store.dispatch('jobEvaluation/loadPlatforms');
	},
	created() {
		const { id } = this.$route.params;
		if (id) {
			this.params.subProcessId = id;
		}
		this.loadApplicants();
	},
	methods: {
		handleDocumentClick(event) {
			if (!event.target.closest('.app-tooltip-button') && !event.target.closest('.options-container')) {
				this.showOptions = null;
			}
		},
		addNewApplicant() {
			this.editApplicant = false;
			this.focusedApplicant = {};
			this.$refs.addApplicant.open();
		},
		async InterviewToApplicant(applicant) {
			this.focusedApplicant = applicant;
			try {
				const { data: response } = await this.$httpPraktiko.get(`applicants-recruitment/detail/${applicant.recruitmentId}/${applicant.applicantId}`);
				if (response.interview) {
					if (Object.keys(response.interview).length > 0) {
						this.dataInterview = response.interview;
					} else {
						this.dataInterview = response.recruitment.steps.config[2].details;
					}
				} else {
					this.dataInterview = response.recruitment.steps.config[2].details;
				}
				this.$store.dispatch('recruitment/dataInterview', this.dataInterview);
				this.$store.dispatch('recruitment/applicantSelected', this.focusedApplicant);
				this.goTo('conduct-interview');
			} catch (error) {
				this.showGenericError();
			}
		},
		async evaluationApplicantDialog(applicant) {
			try {
				const { data: response } = await this.$httpPraktiko.get(`applicants-recruitment/detail/${applicant.recruitmentId}/${applicant.applicantId}`);
				this.experienceTime = response.recruitment.job.experienceTime;
				this.dataFactors = response.factors.length > 0 ? response.factors
					: response.recruitment.steps.config.find(c => c.code === 'CAR').details;
				if (response.interview !== null) {
					this.dataFactors[0].subFactors = response.interview.subFactors;
					this.dataFactors[0].totalScore = response.interview.totalScore;
					let concatComentaries = '';
					this.dataFactors[0].subFactors.forEach((sf) => {
						concatComentaries += sf.comentary;
					});
					this.dataFactors[0].comentary = concatComentaries;
				}
				this.$nextTick(() => {
					this.$refs.evaluationApplicant.open();
				});
			} catch (error) {
				this.showGenericError();
			}
		},
		async loadApplicants() {
			const params = {
				...this.params,
			};
			if (this.numApplicants && this.numApplicants >= 3 && this.numApplicants !== '') {
				params.numApplicants = this.numApplicants;
			}
			try {
				const { data: response, headers } = await this.$httpPraktiko.get(`applicants-recruitment/${this.dataProcessSelected.id}`, { params });
				this.rows = response;
				this.rows = this.rows.map((r) => {
					const newR = { ...r };
					if (newR.factors.length > 0) {
						const sumTotalScores = newR.factors
							.reduce((acum, factor) => acum + factor.totalScore, 0);
						newR.sumTotalScores = roundTo(sumTotalScores, 2);
					} else {
						newR.sumTotalScores = '-';
					}
					return newR;
				});
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
				if (this.rows.length > 0) {
					const { recruitment } = this.rows[0];
					const { data: description } =
						await this.$httpPraktiko.get(`job-description/detail-profile/${recruitment.jobId}`);
					this.jobDescription = description;
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			this.loadApplicants();
		},
		onSearchEvent(search) {
			this.params.search = search.trim() || null;
			this.changePage(1);
		},
		changeColor(fieldName) {
			this.columns.forEach((c, index) => {
				if (c.fieldName !== fieldName && c.color) {
					this.$set(this.columns, index, { ...c, color: 'gray' });
				}
			});
		},
		changeSort({ fieldName, sortDirection }) {
			this.params.sortField = fieldName;
			this.params.sortDirection = sortDirection;
			this.loadApplicants();
		},
		async savedNewApplicant(applicant) {
			const method = this.editApplicant ? 'patch' : 'post';
			const url = this.editApplicant ? `applicants/${this.focusedApplicant.applicantId}`
				: 'applicants-recruitment';
			const message = this.editApplicant ? 'Editado' : 'Agregado';
			const additionalInformation = {
				salaryExpectation: Number(applicant.salaryExpectation),
				typeApplicant: {
					id: this.editApplicant
						? this.focusedApplicant.additionalInformation.typeApplicant.id
						: applicant.typeApplicantId.id,
					name: this.editApplicant
						? this.focusedApplicant.additionalInformation.typeApplicant.name
						: applicant.typeApplicantId.name,
				},
				placeOfResidence: applicant.placeOfResidence,
			};
			if (this.focusedApplicant && this.focusedApplicant.additionalInformation
				&& this.focusedApplicant.additionalInformation.questions) {
				additionalInformation.questions = this.focusedApplicant.additionalInformation.questions;
			}
			const body = {
				additionalInformation,
				name: applicant.name,
				lastName: applicant.lastName,
				phoneNumber: applicant.phone,
				typeDocument: applicant.typeDocument,
				documentNumber: applicant.documentNumber,
				email: applicant.email,
				gender: applicant.gender,
				civilStatusId: applicant.civilStatusId,
				dateBirth: applicant.dateBirth,
				age: Number(applicant.age),
				disability: applicant.disability,
				salaryExpectation: Number(applicant.salaryExpectation),
				typeApplicantId: this.editApplicant
					? applicant.typeApplicantId : applicant.typeApplicantId.id,
				status: applicant.status,
				recruitmentId: this.dataProcessSelected.id,
				urlImage: applicant.urlImage,
			};
			try {
				await this.$httpPraktiko[method](url, body);
				this.showNotification(`Postulante ${message} Correctamente`);
				this.focusedApplicant = {};
				this.editApplicant = false;
				this.loadApplicants();
			} catch (error) {
				if (error.data.message === 'APPLICANT_ALREADY_EXIST_IN_RECRUITMENT') {
					this.showNotification('El Postulante ya existe dentro del proceso de Reclutamiento', 'warning');
				} else {
					this.showGenericError();
				}
			}
		},
		async saveEvaluationApplicant(factors) {
			const newFactors = factors.map((f) => {
				const newF = { ...f };
				newF.score = Number(f.score);
				newF.subFactors = f.subFactors.map((sf) => {
					const newSf = { ...sf };
					newSf.score = Number(sf.score);
					return newSf;
				});
				return newF;
			});
			const body = {
				factors: newFactors,
				flag: true,
			};
			try {
				await this.$httpPraktiko.patch(`applicants-recruitment/factors-interview/${this.focusedApplicant.recruitmentId}/${this.focusedApplicant.applicantId}`, body);
				this.showNotification('Factores Guardados Exitosamente');
				this.editApplicant = false;
				this.loadApplicants();
			} catch (error) {
				this.showGenericError();
			}
		},
		async loadFormat() {
			axios.get('/static/Plantilla.xlsx', {
				responseType: 'blob',
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'plantilla.xlsx');
				document.body.appendChild(link);
				link.click();
			});
		},
		loadExcel() {
			this.$refs.loadFile.click();
		},
		loadApplicantsFile(e) {
			const file = e.target.files[0];
			const fileReader = new FileReader();
			fileReader.onload = (event) => {
				this.loadingFile(event.target.result);
			};
			fileReader.readAsDataURL(file);
			this.showViewTemplate = false;
		},
		async loadingFile(fileData) {
			const url = 'applicants-recruitment/import/xlsx';
			const body = {
				base64: fileData.split(',')[1],
				recruitmentId: this.dataProcessSelected.id,
			};
			try {
				await this.$httpPraktiko.post(url, body).then(() => {
					this.showNotification('Los datos se han agregado correctamente');
					this.loadApplicants();
				});
			} catch (error) {
				const messageSplit = error.data.message.split('-');
				if (messageSplit[0] === 'APPLICANT_ALREADY_EXIST_IN_RECRUITMENT') {
					this.listError = messageSplit[1].split(',');
					this.$refs.listErrorsImports.open();
				} else {
					this.showGenericError();
				}
			}
		},
		messageButton(row) {
			if (row.interview === null) {
				return 'Falta completar entrevista';
			}
			return 'Editar Evaluación del Postulante';
		},
		handleEditApplicant(applicant) {
			this.editApplicant = true;
			this.focusedApplicant = { ...applicant };
			this.$refs.addApplicant.open();
		},
		async downloadReportApplicants({ type, contentType, code }) {
			const body = {
				recruitmentId: this.dataProcessSelected.id,
				// numApplicants: this.numApplicants,
			};
			if (this.numApplicants && this.numApplicants !== '') {
				body.numApplicants = this.numApplicants;
			}
			try {
				const params = {
					code,
				};
				const { data: pdfData } = await this.$httpPraktiko.post('reports/applicants/excel', body, { responseType: 'blob', params });
				const blob = generateBlob(pdfData, contentType);
				showDownloadDialog(blob, 'Reporte Postulantes', type);
			} catch (error) {
				this.showGenericError();
			}
		},
		async handleReportRecruitment(contentType) {
			const body = {
				id: this.dataProcessSelected.id,
				// numApplicants: this.numApplicants,
			};
			if (this.numApplicants && this.numApplicants !== '') {
				body.numApplicants = this.numApplicants;
			}
			try {
				const code = 'recruitment';
				const { data: pdfData } = await this.$httpPraktiko.post(`reports/recruitments-process/${code}/pdf`, body, { responseType: 'blob' });
				const blob = generateBlob(pdfData, contentType);
				showDownloadDialog(blob, 'Reporte_Reclutamiento', 'pdf');
			} catch (error) {
				this.showGenericError();
			}
		},
		getTypeApplicant(id) {
			this.params.type = id.length > 0 ? id.join(',') : null;
			this.loadApplicants();
		},
		getTypePlatforms(id) {
			this.params.platformIds = id.length > 0 ? id.join(',') : null;
			this.loadApplicants();
		},
		getTypeProcess(id) {
			this.params.state = id.length > 0 ? id.join(',') : null;
			this.loadApplicants();
		},
		importApplicants() {
			this.goTo('process-applicant-selection');
		},
		selectAllItems() {},
		async sendEmails() {
			try {
				const validJobDescription = this.jobDescription && this.jobDescription.steps
					&& this.jobDescription.steps.FINS
					&& this.jobDescription.steps.FINS.description
					&& this.jobDescription.steps.FINS.description.instructions
					&& this.jobDescription.steps.FINS.description.instructions.length > 0
					? this.jobDescription.steps.FINS.description.instructions[0].name : null;
				const applicants = this.dataSelected.map(item => ({
					applicantId: item.applicantId,
					email: item.applicant.email,
					name: item.applicant.name,
					lastName: item.applicant.lastName,
					urlImageApplicant: item.applicant.urlImage,
					jobName: item.recruitment.job.name,
					jobDescription: validJobDescription,
					recruitmentName: item.recruitment.steps.config[0].details.name,
					recruitmentId: item.recruitmentId,
					currentAcademicLevel: item.currentAcademicLevel || '',
				}));
				if (applicants.length > 0 && validJobDescription) {
					await this.$httpPraktiko.post('applicants-recruitment/send-approval-messages', { applicants });
					this.showNotification('Mensajes enviados exitosamente');
				} else if (applicants.length === 0) {
					this.showNotification('Seleccione al menos un postulante para enviar el correo', 'warning');
				} else {
					this.showNotification('Por favor, actualice el perfil del puesto en la instrucción formal', 'warning');
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		rowIsSelected(value) {
			if (value.isSelected) {
				this.dataSelected.push(value);
			} else {
				const index = this.dataSelected.findIndex(d => d.id === value.id);
				if (index > -1) {
					this.dataSelected.splice(index, 1);
				}
			}
			this.checkAll = this.rows.every(e => e.isSelected);
		},
		selectedAll(value) {
			this.rows = this.rows.map((r) => {
				const newRow = { ...r };
				newRow.isSelected = value;
				return newRow;
			});
			this.checkAll = value;
			this.dataSelected = value ? [...this.rows] : [];
		},
		async handlerChangeTypeApplicant(option, row) {
			this.row = row;
			this.option = option;
			this.additionalInformation = row.additionalInformation || {};
			if (this.additionalInformation.typeApplicant) {
				this.additionalInformation.typeApplicant = {
					id: option.id,
					name: option.name,
				};
			} else {
				this.additionalInformation.typeApplicant = {
					id: option.id,
					name: option.name,
				};
			}
			try {
				const body = {
					additionalInformation: this.additionalInformation,
				};
				this.showOptions = null;
				if (option.id === 272) {
					if (Object.prototype.hasOwnProperty.call(row.applicant, 'dateBirth')
						&& row.applicant.dateBirth === null
					) {
						this.showNotification('Le solicitamos que verifique que la información del postulante esté completa.', 'warning');
					} else {
						({ data: this.subsidiaries } = await this.$httpPraktiko.get('subsidiaries'));
						this.selectSubsidiary = true;
					}
				} else {
					await this.$httpPraktiko.patch(`applicants-recruitment/${row.recruitmentId}/${row.applicantId}`, body);
					this.showNotification(`El postulante ha cambiado a ${option.name}`);
					this.loadApplicants();
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		toggleOptions(rowId) {
			this.showOptions = this.showOptions === rowId ? null : rowId;
			this.$nextTick(() => {
				const container = this.$el.querySelector('.options-container');
				const button = this.$el.querySelector('.app-tooltip-button');
				if (container && button) {
					const buttonRect = button.getBoundingClientRect();
					const containerWidth = container.offsetWidth;
					const offset = (buttonRect.width - containerWidth) / 2;
					container.style.left = `${buttonRect.left + offset}px`;
				}
			});
		},
		async saveFromModal() {
			try {
				const body = {
					additionalInformation: this.additionalInformation,
					subsidiary: this.subsidiary,
				};
				await this.$httpPraktiko.patch(`applicants-recruitment/${this.row.recruitmentId}/${this.row.applicantId}`, body);
				this.showNotification(`El postulante ha cambiado a ${this.option.name}`);
				this.loadApplicants();
				this.selectSubsidiary = false;
			} catch (error) {
				if (error.data.message === 'EMPLOYEE_ALREADY_EXIST') {
					this.showGenericError('El postulante ya se encuentra registrado como empleado');
				} else {
					this.showGenericError();
				}
			} finally {
				this.close();
			}
		},
		close() {
			this.selectSubsidiary = false;
			this.subsidiary = null;
			this.loadApplicants();
		},
	},
	computed: {
		...mapState('recruitment', {
			dataProcessSelected(state) {
				return pathOr(getLocalData('dataProcessSelected'), ['recruitmentFlow', 'dataProcessSelected'], state.recruitment) || [];
			},
			typeProcess: pathOr([], ['dataSelection', 'typeProcess']),
			typeApplicant: pathOr([], ['dataSelection', 'typeApplicant']),
		}),
		...mapState('jobEvaluation', {
			platforms: pathOr([], ['supplies', 'generalData', 'platforms']),
		}),
		validatStepActivities() {
			return this.dataProcessSelected.steps.config
				.some(ci => ci.code === 'CAR');
		},
		messageBtnInterview() {
			const validation = this.dataProcessSelected.steps.config
				.some(ci => ci.code === 'TMP');
			return !validation ? 'Falta Crear Plantilla de Entrevista para el proceso ' : 'Realizar Entrevista';
		},
		validatStepInterview() {
			return this.dataProcessSelected.steps.config
				.some(ci => ci.code === 'TMP');
		},
	},
	watch: {
		numApplicants: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.loadApplicants();
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.vue-tooltip-theme {
	background-color: black;
	color: white;
	border: none;
}
.filter-input {
	background: map-get($colors, white);
	border: 1px solid map-get($colors, placeholder);
	border-radius: 4px;
	display: block;
	outline: none;
	color: map-get($colors, gray-sidebar);
	padding: 10px 20px;
	width: 70px;

	&::placeholder {
		color: map-get($colors, placeholder) !important;
	}
}
.options-container {
	position: absolute;
	top: 65%;
	left: 100%;
	transform: translateX(-50%);
	min-width: 150px;
	background-color: white;
	border: 1px solid #ccc;
	border-radius: 4px;
	padding: 5px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	z-index: 100;
	white-space: nowrap;
	
	.option {
	  padding: 5px;
	  cursor: pointer;
  
	  &:hover {
		background-color: map-get($colors, green-dark);
		color: map-get($colors, white);
	  }
	}
}
  
td {
	position: relative;
}
  
  .app-tooltip-button {
	position: relative;
	display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/list-applicants.vue